import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { from, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { fromApiEffectSwitchMap } from '@lib/store';
import {
  cancelGetDocumentListRequest,
  failGetDocumentList,
  setGetDocumentList,
  setGetDocumentListFromApi,
  updateGetDocumentList,
  updateGetDocumentListFromApi,
} from './get-document-list.actions';

/**
 * Service to handle async GetDocumentList actions
 */
@Injectable()
export class GetDocumentListEffect {
  /**
   * Set the state with the reply content, dispatch failGetDocumentList if it catches a failure
   */
  public setFromApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(setGetDocumentListFromApi),
      fromApiEffectSwitchMap(
        (reply, action) => setGetDocumentList({ model: reply, requestId: action.requestId }),
        (error, action) => of(failGetDocumentList({ error, requestId: action.requestId })),
        cancelGetDocumentListRequest
      )
    )
  );

  /**
   * Update the state with the reply content, dispatch failGetDocumentList if it catches a failure
   */
  public updateFromApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(updateGetDocumentListFromApi),
      mergeMap((payload) =>
        from(payload.call).pipe(
          map((reply) => updateGetDocumentList({ model: reply, requestId: payload.requestId })),
          catchError((err) => of(failGetDocumentList({ error: err, requestId: payload.requestId })))
        )
      )
    )
  );

  constructor(protected actions$: Actions) {}
}
